import { type ReactNode } from "react";
import { useNotificationSocket } from "@/hooks/useNotificationSocket";

export function NotificationSocketProvider({ children }: { children: ReactNode }) {
  useNotificationSocket();
  return <>{children}</>;
}
